<template>
  <header class="c-main-header">
    <div class="c-main-header__inner">
      <div class="c-main-logo">
        <span class="c-main-logo__img">
          <img
            src="https://tuango3.s3.us-east-2.amazonaws.com/assets/logo-tuango-orange.svg"
            alt="Tuango logo"
          />
        </span>
        <!--        <span class="c-main-logo__title">{{ $t("SHARED__AND") }}</span>
        <span class="c-main-logo__at">
          <img src="/img/air_transat_logo.png" alt="Air Transat logo" />
        </span>
        <span class="c-main-logo__title">{{ $t("SHARED__AND") }}</span>
        <span class="c-main-logo__idc">
          <img src="/img/idc_logo.png" alt="IDC logo" />
        </span>-->
      </div>

      <span
        class="c-main-header__text"
        v-html="$t('SHARED__HEADER_TEXT')"
      ></span>

      <lang-switcher></lang-switcher>
    </div>
  </header>
</template>

<script>
import LangSwitcher from "../UI/LangSwitcher"

export default {
  name: "MainHeader",
  components: {
    LangSwitcher
  }
}
</script>

<style scoped></style>
